import type { PageTheme } from '@backstage/theme';
import { genPageTheme } from '@backstage/theme';
import { COLORS } from '../colors';

const emptyShape = `url("")`;

/**
 * This file is used for specifying themeIds and type colors.
 * Examples on where to use this:
 *  <Page themeId="home">
 *
 *  or in a yaml file:
 *
 *  spec:
 *    type: plugin
 *
 */
export const darkPageTheme: Record<string, PageTheme> = {
  // Pages
  dashboard: genPageTheme({ colors: [COLORS.CRIMSON_5], shape: emptyShape }),
  documentation: genPageTheme({
    colors: [COLORS.CYAN_6],
    shape: emptyShape,
  }), // Also works for type
  home: genPageTheme({ colors: [COLORS.INDIGO_5], shape: emptyShape }),
  onboarding: genPageTheme({ colors: [COLORS.TEAL_5], shape: emptyShape }), // Also works for type
  playground: genPageTheme({ colors: [COLORS.GRASS_5], shape: emptyShape }),
  tool: genPageTheme({ colors: [COLORS.RED_4], shape: emptyShape }),
  // Component
  library: genPageTheme({ colors: [COLORS.INDIGO_5], shape: emptyShape }),
  other: genPageTheme({ colors: [COLORS.INDIGO_5], shape: emptyShape }),
  plugin: genPageTheme({ colors: [COLORS.INDIGO_5], shape: emptyShape }),
  website: genPageTheme({ colors: [COLORS.INDIGO_5], shape: emptyShape }),
  // API
  service: genPageTheme({
    colors: [COLORS.PURPLE_5],
    shape: emptyShape,
  }),
  apis: genPageTheme({ colors: [COLORS.PURPLE_5], shape: emptyShape }),
  openapi: genPageTheme({ colors: [COLORS.PURPLE_5], shape: emptyShape }),
  // Resource
  cache: genPageTheme({ colors: [COLORS.TOMATO_7], shape: emptyShape }),
  database: genPageTheme({ colors: [COLORS.TOMATO_7], shape: emptyShape }),
  'kubernetes-cluster': genPageTheme({
    colors: [COLORS.TOMATO_7],
    shape: emptyShape,
  }),
  storage: genPageTheme({ colors: [COLORS.TOMATO_7], shape: emptyShape }),
  notification: genPageTheme({
    colors: [COLORS.NOTIFICATION],
    shape: emptyShape,
  }),
};

export const lightPageTheme: Record<string, PageTheme> = {
  // Pages
  dashboard: genPageTheme({ colors: [COLORS.CRIMSON_8], shape: emptyShape }),
  documentation: genPageTheme({
    colors: [COLORS.CYAN_8],
    shape: emptyShape,
  }), // Also works for type
  home: genPageTheme({ colors: [COLORS.INDIGO_8], shape: emptyShape }),
  onboarding: genPageTheme({ colors: [COLORS.TEAL_8], shape: emptyShape }), // Also works for type
  playground: genPageTheme({ colors: [COLORS.GRASS_8], shape: emptyShape }),
  tool: genPageTheme({ colors: [COLORS.ORANGE_8], shape: emptyShape }),
  // Component
  library: genPageTheme({ colors: [COLORS.INDIGO_8], shape: emptyShape }),
  other: genPageTheme({ colors: [COLORS.INDIGO_8], shape: emptyShape }),
  plugin: genPageTheme({ colors: [COLORS.INDIGO_8], shape: emptyShape }),
  website: genPageTheme({ colors: [COLORS.INDIGO_8], shape: emptyShape }),
  // API
  service: genPageTheme({
    colors: [COLORS.PURPLE_8],
    shape: emptyShape,
  }),
  apis: genPageTheme({ colors: [COLORS.PURPLE_8], shape: emptyShape }),
  openapi: genPageTheme({ colors: [COLORS.PURPLE_8], shape: emptyShape }),
  // Resource
  cache: genPageTheme({ colors: [COLORS.TOMATO_8], shape: emptyShape }),
  database: genPageTheme({ colors: [COLORS.TOMATO_8], shape: emptyShape }),
  'kubernetes-cluster': genPageTheme({
    colors: [COLORS.TOMATO_8],
    shape: emptyShape,
  }),
  storage: genPageTheme({ colors: [COLORS.TOMATO_8], shape: emptyShape }),
  notification: genPageTheme({
    colors: [COLORS.NOTIFICATION],
    shape: emptyShape,
  }),
};
